<template>
  <LlSelect
    ref="expenseRef"
    class="remove-all-input-styling"
    data-cy="expense-code-dropdown"
    label="Expense Code"
    label-class="text-sm at-choose-client remove-outline"
    is-autocomplete
    clearable
    :hide-details="true"
    :model-value="selectedCode"
    :items="expenseState.expenseCodes"
    :loading="expenseState.loading"
    placeholder="Expense Code"
    :item-props="(item) => ({ disabled: item.disabled })"
    :menu-props="{ maxWidth: expenseRef?.$el?.offsetWidth }"
    :disabled="disabled"
    @update:model-value="handleCodeChange"
  />
</template>
<script setup lang="ts">
import { onMounted, reactive, ref, watch } from 'vue';
import { useCodeStore } from '@/services/useCodeStore';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import LlSelect from '@/components/LlSelect.vue';

const codeStore = useCodeStore();
const { handleError } = useSnackbarHandler();
const emit = defineEmits(['update:modelValue', 'codeChange']);

const props = defineProps({
  modelValue: {
    type: Object,
    required: false,
    default: () => ({ id: '', label: '' }),
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const expenseRef = ref(null);
const selectedCode = ref(props.modelValue);

const expenseState = reactive({
  loading: false,
  expenseCodes: [],
});

onMounted(async () => {
  try {
    expenseState.loading = true;
    expenseState.expenseCodes = await codeStore.expenseCodes();
    populateSelected();
  } catch (error) {
    handleError(error);
  } finally {
    expenseState.loading = false;
  }
});

const populateSelected = () => {
  if (props.modelValue?.id) {
    selectedCode.value =
      expenseState.expenseCodes.find((e) => e.id === props.modelValue.id) ||
      props.modelValue;
  } else {
    selectedCode.value = { id: '', label: '' };
  }
};

const handleCodeChange = (value) => {
  selectedCode.value = value;
  emit('update:modelValue', value);
  emit('codeChange', value);
};

watch(
  () => props.modelValue,
  () => {
    populateSelected();
  },
);
</script>
